<template>
<Content />
</template>
<script route="/fin/contract_setting">
  import Content from './content.jsx'
  export default {
    components:{
      Content
    }
  }
</script>
